import type { ReactNode } from 'react';
import { ccVar } from '../../lib/css';
import { cn } from '../../lib/utils';

type CalloutType = 'tip' | 'note' | 'warn' | 'danger';

const TYPE: Record<CalloutType, { cc: string; label: string }> = {
  tip: { cc: 'var(--c-green)', label: 'Tip' },
  note: { cc: 'var(--accent)', label: 'Note' },
  warn: { cc: 'var(--c-amber)', label: 'Heads up' },
  danger: { cc: 'var(--neg)', label: 'Careful' },
};

export interface CalloutProps {
  type?: CalloutType;
  /** override the default label for the type */
  title?: string;
  children?: ReactNode;
  className?: string;
}

/** A tinted, left-bordered aside for tips/warnings inside a post. */
export const Callout = ({ type = 'note', title, children, className }: CalloutProps) => {
  const { cc, label } = TYPE[type];
  return (
    <div
      style={ccVar(cc)}
      className={cn(
        'my-5 rounded-8 border border-line border-l-2 border-l-[var(--cc)] bg-[color-mix(in_srgb,var(--cc)_7%,transparent)] px-4 py-3 text-15 text-text-2',
        className,
      )}
    >
      <div className="mb-1 text-14 font-medium text-[var(--cc)]">
        {title ?? label}
      </div>
      <div className="[&>*:last-child]:mb-0 [&>p]:my-1">{children}</div>
    </div>
  );
};
